import { IRule } from './rule';
import { ValidationResultErrorMessage } from '../models/validation-result-error-message.model';
import { AdditionalField } from '../../models/additional-field.model';
import { OrderValidationResult } from '../models/order-validation-result.model';
import { AdditionalFieldHelper } from '../../services/additional-field-helper.service';
import { AppInjector } from 'projects/dop-core/src/public-api';
import { CurrentOrder } from '../../models/current-order.model';
import { OrderCommandService } from '../../data-service/order-command.service';
import { OrderState } from '../../enums/order-state.enum';

export class OrderAdditionalFieldsRule implements IRule {

    additionalFieldHelper: AdditionalFieldHelper;
    currentOrder: CurrentOrder;
    orderCommandService: OrderCommandService;

    constructor(order: CurrentOrder) {
        const injector = AppInjector.getInjector();
        this.additionalFieldHelper = injector.get(AdditionalFieldHelper);
        this.currentOrder = order;
        this.orderCommandService = injector.get(OrderCommandService);
    }

    async validate(): Promise<OrderValidationResult> {
        let deletedAfs: AdditionalField[];
        const mandatoryAfs = this.additionalFieldHelper.getOrderMandatoryAfs();
        const optionalAfs = this.additionalFieldHelper.getOrderOptionalAfs()
            .filter(af => this.currentOrder.additionalFields.map(x => x.code).indexOf(af.code) !== -1);
        const allAfCodes = mandatoryAfs.concat(optionalAfs).map(af => af.code);
        if (allAfCodes && allAfCodes.length > 0) {
            deletedAfs = this.currentOrder.additionalFields
                .filter(adfs => !(allAfCodes.indexOf(adfs.code) !== -1));
        }
        const newlyAddedAfs = this.getNewlyAddedAf(mandatoryAfs.concat(optionalAfs), this.currentOrder.additionalFields);
        if (newlyAddedAfs && newlyAddedAfs.length > 0) {
            this.orderCommandService.addOrderAfs(this.currentOrder.OrderCode, this.additionalFieldHelper.buildAfDtoList(newlyAddedAfs));
            this.currentOrder.additionalFields = this.currentOrder.additionalFields.concat(newlyAddedAfs);
        }
        if (this.currentOrder.orderState === OrderState.Pending ||
            this.currentOrder.orderState === OrderState.EditFavoriteOrder) {
            if (deletedAfs && deletedAfs.length > 0) {
                deletedAfs.forEach(deaf => {
                    this.orderCommandService.deleteAfFromOrder(this.currentOrder.OrderCode, deaf.code).toPromise().then(_ => { });
                });
            }
        }
        if (this.currentOrder.orderState === OrderState.Submitted || this.currentOrder.orderState === OrderState.FavoriteOrder) {
            this.currentOrder.additionalFields = this.currentOrder.additionalFields
                .filter(af => !((deletedAfs.map(afg => afg.code).indexOf(af.code) !== -1)));
        }
        this.mapAdditionalFieldValuesToCurrentOrder();
        const result = new OrderValidationResult();
        result.isValid = true;
        if (this.isMandatoryAfMissing()) {
            result.isValid = false;
            result.errorMessage = ValidationResultErrorMessage.MandatoryOrderAdditionalFields;
        }
        result.newOrderAfCodes = newlyAddedAfs;
        return result;
    }

    isMandatoryAfMissing() {
        let isMandatoryMissing = false;
        if (this.currentOrder.additionalFields.some(af => af.isMandatory && (!af.value
            || (af.value && af.value.length < 0)))) {
            isMandatoryMissing = true;
        }
        return isMandatoryMissing;
    }
    getNewlyAddedAf(masterData: AdditionalField[], orderAfs: AdditionalField[]) {
        const orderAfCodes = orderAfs.map(c => c.code);
        const newlyAddedAfs = masterData.filter(af => !(orderAfCodes.indexOf(af.code) !== -1));
        return newlyAddedAfs;
    }

    mapAdditionalFieldValuesToCurrentOrder() {
        const afds: AdditionalField[] = [];
        const orderAfs: AdditionalField[] = [];
        afds.push(...this.currentOrder.additionalFields);
        afds.forEach(c => {
            const a = this.additionalFieldHelper.getOrderMandatoryAfs().filter(m => m.code === c.code).shift();
            this.pushAdditionalFields(a, orderAfs, c.value);
        });
        afds.forEach(c => {
            if (c.code) {
                const a = this.additionalFieldHelper.getOrderOptionalAfs().filter(m => m.code === c.code).shift();
                this.pushAdditionalFields(a, orderAfs, c.value);
            }
        });

        this.currentOrder.additionalFields = orderAfs;
    }

    private pushAdditionalFields(a: AdditionalField, orderAfs: AdditionalField[], afValue: any) {
        if (a) {
            a.value = afValue ? afValue : null;
            a.value = this.additionalFieldHelper.formatAfValue(a);
            orderAfs.push(a);
        }
    }

}
